import PropTypes from 'prop-types';

function WindowSliderDivider(props) {
  const {
    label,
  } = props;

  if (label) {
    return (
      <div className="bg-white border-pxCaseHeaderSecondaryBrdr border-y border-solid flex items-center justify-center gap-2 h-6 px-3 text-xs font-semibold text-pxPrimary">
        <div className="h-0.5 flex-1 rounded-full bg-pxPrimary/20" />
        {label}
        <div className="h-0.5 flex-1 rounded-full bg-pxPrimary/20" />
      </div>
    );
  }

  return (
    <div className="bg-white border-pxCaseHeaderSecondaryBrdr border-y border-solid flex items-center justify-center h-5 cursor-row-resize">
      <div className="h-1.5 w-10 rounded-full bg-pxPrimary" />
    </div>
  );
}

WindowSliderDivider.propTypes = {
  label: PropTypes.string,
};

export default WindowSliderDivider;
